import React from "react";



function Sub(){

    return(
    <div style={{backgroundColor:"#776E6C"}}>
      
              
        <table border="0" >
        <tr>
        <th>   
           
           <img src="https://www.toyoos.com/wp-content/uploads/2018/07/Platinum-Membership.png" width="100" height="100" style={{marginLeft:240 }}/>
           </th>
        
        
        <th>
        <h2 style={{marginLeft:150 }}>Upgrade Your Membership Plan </h2>
        </th>
        <th>
            <a
                  style={{marginLeft:150 }} type="button" class="btn btn-primary" href="/subscribe">Subscribe </a>
        </th>
        </tr>
    </table>
    </div>
 
   
       
        
)}

export default Sub;